var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Experience"},[_c('Ribbon'),(_vm.$route.params.section == undefined 
              || _vm.$route.params.section == 'weave'
              || _vm.$route.params.section == 'recenter')?_c('Weave'):_vm._e(),(_vm.isAfter(_vm.$route.params.section, 'weave') && _vm.$route.params.section != 'support')?_c('Story'):_vm._e(),(_vm.use_support)?_c('Support'):_vm._e(),_c('AudioComp')],1)}
var staticRenderFns = []

export { render, staticRenderFns }